import { Trans } from 'react-i18next';
import FeatureCard from '../components/FeatureCard';
import PropertyRadio from '../components/PropertyRadio';

const AstroSubmodeCluster = ({ submode, handleChange, isSDTriggeredEnabled, style }) => (
    <FeatureCard title={<Trans i18nKey="Submode" />} style={ style || { width: '25%' }}>
        <PropertyRadio
            property={submode}
            isChecked={submode.value === '0'}
            valueForTrue={"0"}
            title={<Trans i18nKey="Astro_Based" />}
            handleChange={handleChange} />
        <PropertyRadio
            disabled={submode.valueMeta.max === "0"}
            property={submode}
            isChecked={submode.value === '1'}
            valueForTrue={"1"}
            title={<Trans i18nKey="Time_Based" />}
            handleChange={handleChange} />
        <PropertyRadio
            disabled={!isSDTriggeredEnabled}
            property={submode}
            isChecked={submode.value === '2'}
            valueForTrue={"2"}
            title={<Trans i18nKey="SD_triggered" />}
            handleChange={handleChange} />
    </FeatureCard>
);

export default AstroSubmodeCluster;
